var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84149 6.52689L8.84149 1.05642L14.312 1.05641C14.7072 1.05641 15.0862 1.21341 15.3657 1.49287C15.6451 1.77233 15.8021 2.15136 15.8021 2.54657L15.8021 18.4678C15.8021 18.8631 15.6451 19.2421 15.3657 19.5215C15.0862 19.801 14.7072 19.958 14.312 19.958L2.37102 19.958C1.9758 19.958 1.59678 19.801 1.31732 19.5216C1.03786 19.2421 0.880859 18.8631 0.880859 18.4678L0.880859 9.01705L6.35134 9.01705C7.01177 9.01705 7.64515 8.7547 8.11214 8.2877C8.57914 7.82071 8.84149 7.18732 8.84149 6.52689ZM2.08551 6.52443L6.34888 2.26106L6.34888 6.52443L2.08551 6.52443Z",
    stroke: "#CE1111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBorder);
export default __webpack_public_path__ + "static/media/file-border.dce977209ea91f59c18e23aa78ef93e2.svg";
export { ForwardRef as ReactComponent };